import React, { useState, useEffect, useMemo } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import { formatDateTimeForDisplay } from "../../../utils/dateUtils";
import { useTranslation } from "react-i18next";
import { formatPriceWithDollar } from "../../../utils/currency";

const PaymentSchedTab = ({ data, activeColor = "secondary" }) => {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!data) return;
    const list = Array.isArray(data) ? data : [];

    const normalized = list.map((item, idx) => ({
      id: idx + 1,
      date: item.date,
      amount: item.amount,
      status: item.status,
      type: item.type,
      note: item.note,
    }));
    setRows(normalized);
  }, [data]);

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);

  const formatDisplayText = (text) => {
    if (!text) return '';
    return text
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const columns = useMemo(() => [
    {
      Header: t('common.date', 'Date'),
      accessor: "date",
      Cell: ({ value }) => formatDateTimeForDisplay(value),
    },
    {
      Header: t('common.amount', 'Amount'),
      accessor: "amount",
      Cell: ({ value }) => formatPriceWithDollar(value),
    },
    {
      Header: t('common.status', 'Status'),
      accessor: "status",
      Cell: ({ value }) => <span>{formatDisplayText(value)}</span>
    },
    {
      Header: t('common.type', 'Type'),
      accessor: "type",
      Cell: ({ value }) => <span>{formatDisplayText(value)}</span>
    },
    {
      Header: t('transactions.note', 'Note'),
      accessor: "note",
    },
  ], [t]);

  const paginatedData = useMemo(() => {
    const start = currentPage * pageSize;
    return rows.slice(start, start + pageSize);
  }, [rows, currentPage, pageSize]);

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <h2 className="mb-0">
                {t('common.recordsInTotal', 'Total Records')}: {rows.length}
              </h2>
            </CardHeader>
            <CardBody>
              {!rows || rows.length === 0 ? (
                <div className="text-muted">{t('common.noData', 'No payment schedule found')}</div>
              ) : (
                <>
                  <ReactTable
                    activeColor={activeColor}
                    data={paginatedData}
                    columns={columns}
                    className="-striped -highlight"
                    manualPagination={true}
                    pageCount={Math.ceil(rows.length / pageSize)}
                    pageIndex={currentPage}
                    pageSize={pageSize}
                    onPageChange={(index) => setCurrentPage(index)}
                    onPageSizeChange={(size) => {
                      setPageSize(size);
                      setCurrentPage(0);
                    }}
                  />
                  <div className="mt-2 text-right">
                    <small>{rows.length} {t('transactions.recordsInTotal', 'records in total')}</small>
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PaymentSchedTab;
